/**
 * Delivery Pricing block entry.
 *
 * Importing the SCSS here makes Vite bundle the block's CSS. GSAP is lazy-loaded
 * only when the block is present and motion is allowed.
 */

import './index.scss';

const deliveryPricingBlocks = document.querySelectorAll('.delivery-pricing');

if (deliveryPricingBlocks.length) {
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	if (!reduceMotion) {
		deliveryPricingBlocks.forEach((block) => {
			if (block.getBoundingClientRect().bottom > 0) {
				block.dataset.animate = '';
			}
		});

		(async () => {
			const { gsap } = await import('gsap');
			const { ScrollTrigger } = await import('gsap/ScrollTrigger');

			gsap.registerPlugin(ScrollTrigger);

			document.querySelectorAll('.delivery-pricing[data-animate]').forEach((block) => {
				const ctx = gsap.context(() => {
					const table = block.querySelector('.delivery-pricing__table');

					if (table) {
						gsap.to(table, {
							opacity: 1,
							y: 0,
							duration: 0.8,
							ease: 'power3.out',
							scrollTrigger: {
								trigger: block,
								start: 'top 85%',
								once: true,
							},
						});
					}
				}, block);

				block._gsapCtx = ctx;
			});
		})();
	}
}
